<template>
  <v-card class="rounded-card card-shadow">
    <v-card-text>
      <v-row dense>
        <v-col cols="12" sm="6" md="7">
          <p class="mb-1">
              <span class="headline font-weight-bold text--primary">
                {{ compra.fornecedor.pessoa.nome }}
              </span>
          </p>
        </v-col>
        <v-col v-if="hasModuleGerencia"
               cols="12"
               sm="6"
               md="5"
               class="text-right">
          <px-compra-aprove-dialog
              v-if="isPendente && !isRecusadoCancelado && isAtrasado"
              :compraId="compra.id"
              @movimentar="onMovimentar"/>
          <px-compra-cancelar-dialog
              v-if="!hideCancelado"
              :compra="compra"
              @movimentar="onMovimentar"/>
          <px-compra-enviar-ordem-dialog
              v-if="isPendenteComprador"
              :compra="compra"
              @movimentar="onMovimentar"/>
          <px-detalhes-compra-menu :compra="compra" @change="onMovimentar"/>
        </v-col>
      </v-row>
      <v-row dense no-gutters class="mb-2">
        <v-col cols="12">
          <px-situacao-compra-tag chip-class="mr-2" :situacao="compra.situacao"/>
          <px-entrega-menu v-if="hasControleEntrega && !isRecusadoCancelado"
                           :item="compra"
                           :has-role-gestor-entrega="hasRoleGestorEntrega"
                           @change-data-entrega="updatePrevisaoEntrega"
                           @change-entrega="finalizarEntrega">
            <template v-slot:activator="{ on }">
              <px-situacao-entrega-compra v-on="on"
                                          :situacao="compra.situacaoEntrega"/>
            </template>
          </px-entrega-menu>
          <px-indicador-recebimento :compra="compra"/>
        </v-col>
      </v-row>
      <p class="subtitle-card-detail">
        <v-icon>mdi-pound</v-icon>
        <px-span-tooltip
          bottom
          :text="textCodigoCompra"
          :tooltip="tooltipCodigoCompra"/>
      </p>
      <p class="subtitle-card-detail">
        <v-icon>mdi-domain</v-icon>
        {{ compra.fornecedor.pessoa.cnpj | cnpj }}
      </p>
      <p class="subtitle-card-detail">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on">
              <v-icon>mdi-map-marker</v-icon>
              {{ compra.fornecedor.endereco | endereco }}
            </span>
          </template>
          <span>Endereço do fornecedor</span>
        </v-tooltip>
      </p>
      <p class="subtitle-card-detail">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on">
              <v-icon>mdi-calendar</v-icon>
              {{ compra.dataCompra | date }}
            </span>
          </template>
          <span>Data da compra</span>
        </v-tooltip>
      </p>
      <p class="subtitle-card-detail" v-if="compra.codigoInternoFornecedor">
        <v-icon>mdi-alpha-c-box-outline</v-icon>
        <px-span-tooltip
          bottom
          :text="compra.codigoInternoFornecedor"
          tooltip="Código interno do fornecedor"/>
      </p>
      <div class="text--primary">
        <v-row dense>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Tipo de frete</span>
            <div>
              {{ compra.frete.tipoFrete }}
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Previsão de entrega</span>
            <div>
              {{ compra.dataPrevisaoEntrega | date | naoInformado }}
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Data de entrega solicitante</span>
            <div>
              {{ compra.dataNecessidadeEntregaSolicitacao | date | naoInformado}}
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Data de Faturamento</span>
            <div>
              {{ compra.dataFaturamento | date | naoInformado }}
            </div>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Forma de pagamento</span>
            <div>
              <px-forma-pagamento :forma-pagamento="compra.formaPagamento"
                                  :prazo-pagamento="compra.prazoPagamento"/>
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Modo de pagamento</span>
            <div>
              {{ modoPagamento | naoInformado }}
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Observações internas</span>
            <div>
              <px-show-large-text :large-text="compra.observacao"/>
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Mensagem para o fornecedor</span>
            <div>
              <px-show-large-text :large-text="compra.mensagem"/>
            </div>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Projeto</span>
            <div>
              {{ projeto | naoInformado }}
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Centro de custo</span>
            <div>
              {{ centroCusto | naoInformado | truncate(40)}}
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Mensagem para o comprador</span>
            <div>
              <px-show-large-text :large-text="compra.mensagemFornecedor"/>
            </div>
          </v-col>
          <v-col cols="12" sm="3" v-if="!hasTransport">
            <span class="caption font-weight-bold">Transportadora</span>
            <div>
              {{ compra.transportadora.pessoa.nome }}
            </div>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="3" v-if="compra.usuario">
            <span class="caption font-weight-bold">Responsável</span>
            <div>
              {{ compra.usuario.nome }}
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Finalidade da Compra</span>
            <div v-if="compra.finalidadeCompra">
              <px-finalidade-compra-value :finalidade-compra="compra.finalidadeCompra"/>
            </div>
            <div v-else>
              Não Informado
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Observação do frete</span>
            <div>
              <px-show-large-text :large-text="compra.frete.observacaoFrete"/>
            </div>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Anexos</span>
            <div v-if="compra.arquivos.length">
              <px-anexo-chip :files="compra.arquivos"
                             download-base-path="files/download-comprador"/>
            </div>
            <div v-else>
              Nenhum anexo informado
            </div>
          </v-col>
          <v-col cols="12" sm="3" v-if="isRecusadoCancelado">
            <span class="caption font-weight-bold">Motivo da recusa/cancelamento</span>
            <div>
              <px-show-large-text :large-text="compra.motivoRecusa"/>
            </div>
          </v-col>
          <v-col cols="12" sm="3" v-if="compra.tipoNotaEntrada">
            <span class="caption font-weight-bold">Tipo de nota de entrada</span>
            <div>
              {{ compra.tipoNotaEntrada.descricao }}
            </div>
          </v-col>
        </v-row>
          <px-campos-integracao v-if="cadastrosAdicionais"
                                type="compra-view"
                                :form-data="cadastrosAdicionais"/>
        <v-row dense>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Número da nota fiscal</span>
            <px-compra-numero-nota-fiscal :disabled="!hasModuleGerencia" :compra="compra"/>
          </v-col>
        </v-row>
      </div>
    </v-card-text>
    <px-confirm-dialog ref="confirm"/>
  </v-card>
</template>

<script>
import { SituacaoCompra, TipoFrete, SituacaoEntregaCompra } from 'px-business-components';
import CompraService from '@/modules/compra/compra-service';
import { mapGetters } from 'vuex';
import { cadastrosAdicionaisToMap } from '@/utils/campos-integracao-utils';
import ObjectUtils from '@/utils/object-utils';
import CompraNumeroNotaFiscal from '@/modules/compra/detalhes/CompraNumeroNotaFiscal.vue';
import CompraEnviarOrdemDialog from '../CompraEnviarOrdemDialog.vue';
import CompraCancelarDialog from '../CompraCancelarDialog.vue';
import IndicadorRecebimento from '../IndicadorRecebimento.vue';
import CompraAproveDialog from '../CompraAproveDialog.vue';
import DetalhesCompraMenu from './DetalhesCompraMenu.vue';

export default {
  props: {
    compra: Object,
  },
  data() {
    return {
      loadingCancelar: false,
    };
  },
  computed: {
    ...mapGetters('user', ['hasControleEntrega', 'hasModuleGerencia', 'hasRoleGestorEntrega']),
    centroCusto() {
      return this.compra.centroCusto
        ? ObjectUtils.descWithCodigoInterno(this.compra.centroCusto) : null;
    },
    projeto() {
      return this.compra.projeto ? ObjectUtils.descWithCodigoInterno(this.compra.projeto) : null;
    },
    modoPagamento() {
      return this.compra.modoPagamento ? this.compra.modoPagamento.descricao : null;
    },
    isPendenteComprador() {
      return this.compra.situacao === SituacaoCompra.keys.PENDENTE_COMPRADOR.key;
    },
    isAprovada() {
      return this.compra.situacao === SituacaoCompra.keys.APROVADA.key;
    },
    isPendente() {
      return this.compra.situacao === SituacaoCompra.keys.PENDENTE_COMPRADOR.key
        || this.compra.situacao === SituacaoCompra.keys.PENDENTE_FORNECEDOR.key;
    },
    isAtrasado() {
      return this.checkTempoSemAprovacao(this.compra) >= 1;
    },
    hideCancelado() {
      return this.compra.situacao === SituacaoCompra.keys.CANCELADA.key;
    },
    isRecusadoCancelado() {
      return this.compra.situacao === SituacaoCompra.keys.RECUSADA.key
        || this.compra.situacao === SituacaoCompra.keys.CANCELADA.key;
    },
    isCif() {
      return this.compra.frete.tipoFrete === TipoFrete.keys.CIF.key;
    },
    labelFrete() {
      return this.isCif ? 'Entrega' : 'Embarque';
    },
    hasTransport() {
      return this.compra.transportadora === null;
    },
    cadastrosAdicionais() {
      if (!this.compra.cadastrosAdicionais || !this.compra.cadastrosAdicionais.length) {
        return null;
      }
      return cadastrosAdicionaisToMap(this.compra.cadastrosAdicionais);
    },
    tooltipCodigoCompra() {
      return this.compra.codigoInterno ? 'Código Proxpect / Código OC' : 'Código Proxpect';
    },
    textCodigoCompra() {
      return this.compra.codigoInterno ? `${this.compra.id} / ${this.compra.codigoInterno}` : this.compra.id;
    },
  },
  methods: {
    onMovimentar() {
      this.$emit('movimentar');
    },
    checkTempoSemAprovacao(compra) {
      const dataHoje = new Date();
      const dataCompra = new Date(compra.createdIn);
      const msPorDia = 24 * 60 * 60 * 1000;
      const diasSemAprovacao = (dataHoje.getTime() - dataCompra.getTime()) / msPorDia;
      return Math.floor(diasSemAprovacao, 1);
    },
    updatePrevisaoEntrega(item, dataPrevisao) {
      CompraService.savePrevisaoEntrega(this.compra.id, {
        dataPrevisaoEntrega: dataPrevisao,
      }).then(() => {
        this.compra.dataPrevisao = dataPrevisao;
        this.$toast('Data de entrega atualizada', { color: 'success' });
      });
    },
    finalizarEntrega() {
      CompraService.finalizarEntrega(this.compra.id).then(() => {
        this.compra.situacaoEntrega = SituacaoEntregaCompra.keys.RECEBIDA.key;
        this.$toast('Compra atualizada', { color: 'success' });
      });
    },
  },
  components: {
    pxCompraEnviarOrdemDialog: CompraEnviarOrdemDialog,
    pxCompraCancelarDialog: CompraCancelarDialog,
    pxIndicadorRecebimento: IndicadorRecebimento,
    pxCompraAproveDialog: CompraAproveDialog,
    pxDetalhesCompraMenu: DetalhesCompraMenu,
    pxCompraNumeroNotaFiscal: CompraNumeroNotaFiscal,
  },
};
</script>
